import { render, staticRenderFns } from "./order.vue?vue&type=template&id=6d511922&scoped=true&"
import script from "./order.vue?vue&type=script&lang=ts&"
export * from "./order.vue?vue&type=script&lang=ts&"
import style0 from "./order.vue?vue&type=style&index=0&id=6d511922&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d511922",
  null
  
)

export default component.exports